/**
 * Created by RKL on 07/09/2015.
 */
define('adminLmbAnaDetailsView',[
  'module',
  'marionette',
  'underscore',
  'backbone',
  'app',
  'settings',
  'imageUtils',
  'template!adminLmbAnaDetailsTpl',
  'adminLmbAnaTabs',
  'rolesMixin',
  'backToListBehavior'
], function (
  module,
  Marionette,
  _,
  Backbone,
  App,
  Settings,
  imageUtils,
  viewTpl,
  lmbAnasTabs,
  RolesMixin,
  BackToListBehavior
) {
  'use strict';

  var KitsDetailsView =  Marionette.LayoutView.extend({
    template: viewTpl,

    ui: {
      tab: '.lmbana-tab',
      tabPane: '.tab-pane',
      logo: '.js-logo-holder',
      name: '.p-name',
      code: '.p-code'
    },

    events: {
      'click @ui.tab': 'onTabClick',
      'change @ui.collectionToggle': 'onCollectionToggle'
    },

    regions: {
      lmbAnaDetailTab: '#detail-tab',
      lmbAnaResTransTab: '#restrans-tab',
      lmbAnaAnaAssayTab: '#anaassay-tab'
    },

    behaviors: {
      BackToList: {
        behaviorClass: BackToListBehavior,
        redirectUrl: 'admin/lmbanas'
      }
    },

    serializeData: function() {
      var templateData = this.model.toJSON();
      templateData.lmbAnasTabs = lmbAnasTabs;
      templateData.compulogoCollection = this.model.get('compulogoCollection');
      return templateData;
    },

    onRender: function() {
      if (this.options.data.tab) {
        this.ui.tab.removeClass('active');
        this.$el.find('.tab-pane').removeClass('active');
        this.$el
          .find('.lmbana-tab[data-name="' + this.options.data.tab.name + '"]')
          .addClass('active');
        this.$el
          .find('.tab-pane[data-name="' + this.options.data.tab.name + '"]')
          .addClass('active');
      }
    },

    onShow: function() {
      $.material.init();
    },

    onTabClick: function(e) {
      var $target = $(e.currentTarget),
        tab = {
          route: $target.data('route'),
          role: $target.data('role'),
          name: $target.data('name')
        };

      this.ui.tab.removeClass('active');
      this.ui.tabPane.removeClass('active');
      $target.addClass('active');
      this.$('.tab-pane[data-name="' + tab.name + '"]').addClass('active');

      this.triggerMethod('click:tab', tab);
    },

    onHeaderChange: function(lmbAna) {
      this.ui.name.text(lmbAna.name);
      this.ui.code.text(lmbAna.code);
    }
  });

  module.exports = KitsDetailsView;
});
